var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#338dc7;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-667 -467)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.919,13.075A9.71,9.71,0,1,1,9.344,6.209l1.324,1.324a7.838,7.838,0,1,0,5.542-2.3s-2.4,0-2.4,0a.936.936,0,0,1-.634-1.625L16.11.917a1.87,1.87,0,0,1,2.644.111l-2.54,2.336A9.723,9.723,0,0,1,25.919,13.075Zm-7.165-5.5L17.5,6.418l-2.778-.012,1.391,1.28a1.87,1.87,0,0,0,2.644-.112Z",
    transform: "translate(662.5 467.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(667 467)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.5a045921.svg";
export { ForwardRef as ReactComponent };